(function () {
  var style = document.createElement('style');
  style.textContent = '@media screen and (max-width: 768px) { .omega-grid-list { grid-template-columns: repeat(2, 1fr) !important; } }';
  document.head.appendChild(style);

  function fixCurrencyFormat() {
    if (window.omegaUtils && window.omegaUtils.getCurrencySymbol) {
      var originalGetCurrency = window.omegaUtils.getCurrencySymbol;
      window.omegaUtils.getCurrencySymbol = function (code) {
        var symbol = originalGetCurrency(code).trim();
        return symbol ? symbol : '';
      };
    }

    var priceSelectors = [
      '.omega-mcpl-item-price-current',
      '.omega-mcpl-item-price-compare',
      '.text-black-price',
      '.text-sale-price',
      '.product-price-inline span',
      '.overlay-subtitle'
    ];

    document.querySelectorAll(priceSelectors.join(',')).forEach(function (el) {
      var text = el.textContent.trim();
      var match = text.match(/^([\d,.]+)\s*([^\d,.]+)$/);
      if (match) {
        el.textContent = match[2] + match[1];
      }
    });
  }

  var modalObserver = new MutationObserver(function () {
    fixCurrencyFormat();
  });

  var modalTarget = document.getElementById('omega-modal-grid');
  if (modalTarget) {
    modalObserver.observe(modalTarget, { childList: true, subtree: true });
  } else {
    var waitModal = new MutationObserver(function (_, obs) {
      var modal = document.getElementById('omega-modal-grid');
      if (modal) {
        obs.disconnect();
        modalObserver.observe(modal, { childList: true, subtree: true });
      }
    });
    waitModal.observe(document.body, { childList: true, subtree: true });
  }

  var gridObserver = new MutationObserver(function () {
    fixCurrencyFormat();
  });

  var gridContainer = document.querySelector('.omega-grid-container');
  if (gridContainer) {
    gridObserver.observe(gridContainer, { childList: true, subtree: true });
  }

  var DESKTOP_PER_PAGE = 15;
  var MOBILE_PER_PAGE = 8;
  var MOBILE_BREAKPOINT = 768;
  var loadMoreBtn = null;
  var visibleCount = 0;

  function getPerPage() {
    return window.innerWidth <= MOBILE_BREAKPOINT ? MOBILE_PER_PAGE : DESKTOP_PER_PAGE;
  }

  function applyLoadMore() {
    var gridList = document.querySelector('.omega-grid-list');
    if (!gridList) return;

    var items = gridList.querySelectorAll('.omega-grid-item');
    var perPage = getPerPage();

    if (loadMoreBtn && loadMoreBtn.parentNode) {
      loadMoreBtn.parentNode.removeChild(loadMoreBtn);
    }

    items.forEach(function (item) {
      item.style.display = '';
    });

    if (items.length <= perPage) return;

    items.forEach(function (item, index) {
      if (index >= perPage) {
        item.style.display = 'none';
      }
    });

    visibleCount = perPage;

    loadMoreBtn = document.createElement('button');
    loadMoreBtn.textContent = 'Show more';
    loadMoreBtn.className = 'omega-load-more-btn';
    loadMoreBtn.style.cssText =
      'display:block;margin:24px auto 0;padding:12px 32px;' +
      'background-color:#000;color:#fff;border:none;border-radius:8px;' +
      'font-size:14px;font-weight:600;cursor:pointer;transition:opacity 0.2s;';

    loadMoreBtn.addEventListener('click', function () {
      var currentPerPage = getPerPage();
      var nextBatch = visibleCount + currentPerPage;

      items.forEach(function (item, index) {
        if (index < nextBatch) {
          item.style.display = '';
        }
      });

      visibleCount = nextBatch;

      if (visibleCount >= items.length) {
        loadMoreBtn.style.display = 'none';
      }
    });

    gridList.parentNode.insertBefore(loadMoreBtn, gridList.nextSibling);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyLoadMore, 200);
  });

  var initObserver = new MutationObserver(function (_, obs) {
    var gridItems = document.querySelectorAll('.omega-grid-item');
    if (gridItems.length > 0) {
      obs.disconnect();
      setTimeout(function () {
        fixCurrencyFormat();
        applyLoadMore();
      }, 300);
    }
  });

  initObserver.observe(document.body, { childList: true, subtree: true });
})();
